module.exports = __webpack_public_path__ + "static/media/other.3ae09e0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/activities/other.png
// module id = 1477
// module chunks = 31